const iconContentGridClass = ".icon-content-grid";

function createIconContentGrids() {
  function init() {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(iconContentGridClass).forEach((container) => {
        const grid = container.querySelector(
          `${iconContentGridClass}__grid-container`
        );
        const controlLeft = container.querySelector(
          `${iconContentGridClass}__controls--left`
        );
        const controlRight = container.querySelector(
          `${iconContentGridClass}__controls--right`
        );

        controlLeft.addEventListener("click", () => {
          if (grid.scrollLeft <= 0) {
            grid.scrollTo({
              left: grid.scrollWidth - grid.scrollLeft,
              behavior: "smooth",
            });
          } else {
            grid.scrollBy({
              left: -container.scrollWidth,
              behavior: "smooth",
            });
          }
        });
        controlRight.addEventListener("click", () => {
          if (grid.scrollLeft >= grid.scrollWidth - grid.scrollLeft) {
            grid.scrollTo({ left: 0, behavior: "smooth" });
          } else {
            grid.scrollBy({
              left: container.scrollWidth,
              behavior: "smooth",
            });
          }
        });
      });
    });
  }

  return {
    init,
  };
}

const iconContentGrids = createIconContentGrids();
iconContentGrids.init();
